/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DataTableCell, columnTypes } from 'yankees-react-utils';
import VideoPlayerButton from '../../../../components/VideoPlayerButton';
import VideoPlaylistButton from '../../../../components/VideoPlaylistButton';

const DrilldownParent = ({ playerid, gameid, pitchtype, fxsubtype, columns, pitchTypeSplits, isInBats, isLive, livePlaylistFn }) => {
    const [rows, setRows] = useState([]);
    const { t: translate } = useTranslation();

    const cleanColumns = [{ id: '', type: columnTypes.NODE, transform: () => ' ' }, ...columns];
    cleanColumns.find((c) => c.id === 'title').colSpan = 2;

    useEffect(() => {
        const matchingPitchTypeData = pitchTypeSplits.filter((x) => x.pitchtype === pitchtype);
        const videoparamsLhh = { pitcherid: playerid, gameid, fxpitchtype: pitchtype, fxsubtype, islhb: true };
        const videoparamsRhh = { pitcherid: playerid, gameid, fxpitchtype: pitchtype, fxsubtype, islhb: false };
        const videoplaylistLhh = isLive ? <VideoPlaylistButton playlist={livePlaylistFn(videoparamsLhh)} /> : (isInBats ? (<VideoPlayerButton {...videoparamsLhh} />) : '-');
        const videoplaylistRhh = isLive ? <VideoPlaylistButton playlist={livePlaylistFn(videoparamsRhh)} /> : (isInBats ? (<VideoPlayerButton {...videoparamsRhh} />) : '-');
        const vslhh = matchingPitchTypeData.find((x) => x.splittype.includes('LHB')) || [];
        const vsrhh = matchingPitchTypeData.find((x) => x.splittype.includes('RHB')) || [];
        if (vslhh) { vslhh.videoplaylist = videoplaylistLhh; }
        if (vsrhh) { vsrhh.videoplaylist = videoplaylistRhh; }
        setRows([
            { title: `${translate('baseball.abbr-versus')} ${translate('baseball.lhh')}`, ...vslhh },
            { title: `${translate('baseball.abbr-versus')} ${translate('baseball.rhh')}`, ...vsrhh },
        ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pitchTypeSplits, pitchtype, gameid]);

    return rows.map((r, i) => (
        <React.Fragment key={r.title}>
            <tr>
                {cleanColumns.map((c) => <DataTableCell key={`${c.id}-${r.title}`} col={c} row={r} colSpan={c.colSpan ?? 1} />)}
            </tr>
            {!i && <tr />}
        </React.Fragment>
    ));
};

DrilldownParent.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    pitchtype: PropTypes.number.isRequired,
    fxsubtype: PropTypes.number,
    playerid: PropTypes.number.isRequired,
    gameid: PropTypes.number.isRequired,
    pitchTypeSplits: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    isInBats: PropTypes.bool.isRequired,
    isLive: PropTypes.bool,
    livePlaylistFn: PropTypes.func,
};

DrilldownParent.defaultProps = {
    isLive: false,
    fxsubtype: null,
    livePlaylistFn: () => {},
};

export default DrilldownParent;
